import { render, staticRenderFns } from "./AddPlotTree.vue?vue&type=template&id=2df00af5&scoped=true"
import script from "./AddPlotTree.vue?vue&type=script&lang=js"
export * from "./AddPlotTree.vue?vue&type=script&lang=js"
import style0 from "./AddPlotTree.vue?vue&type=style&index=0&id=2df00af5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df00af5",
  null
  
)

export default component.exports